import { jsx as _jsx } from "react/jsx-runtime";
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextFormItem } from 'components/custom';
import React from 'react';
import { useTranslation } from 'react-i18next';
const DatePicker = (props, ref) => {
    const { t } = useTranslation('common');
    const { errorMessage, name, placeholder = t('body.dateFormatPlaceholder'), value, ...cmpProps } = props;
    const textFormItemProps = {
        errorMessage,
        name,
        placeholder,
    };
    const paperProps = {
        sx: {
            '& .MuiPickersMonth-monthButton.Mui-disabled': {
                color: (theme) => theme.palette.action.disabled,
            },
            '& .MuiPickersMonth-monthButton.Mui-selected.Mui-disabled': {
                backgroundColor: (theme) => theme.palette.action.disabled,
                color: (theme) => theme.palette.common.white,
            },
        },
    };
    return (_jsx(MuiDatePicker, { value: value ?? null, ref: ref, slots: {
            textField: TextFormItem,
        }, slotProps: {
            desktopPaper: paperProps,
            mobilePaper: paperProps,
            textField: textFormItemProps,
        }, ...cmpProps }));
};
export default React.forwardRef(DatePicker);
